import React from 'react';
import { SECTION } from '../../constants/sections';

const Navigation = ({ onClick }: { onClick?: () => void }) => (
  <>
    {Object.values(SECTION).map((section, index) => (
      <a key={index} href={`#${section.id}`} onClick={onClick}>
        {section.headerTitle}
      </a>
    ))}
  </>
);

export default Navigation;
